import React from "react";
import TableCell from "@mui/material/TableCell";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import Grid from "@mui/material/Grid";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import Box from "@mui/material/Box";
import Tooltip from '@mui/material/Tooltip';

const TableBodyCellComponent = (props) => {
  const row = props.row;
  const columns = props.columns;

  const EditItem = (a) => {
    window.location.href = "/Evaluation/Edit/".concat(a);
  };

  const editIcon = (data) => (
    <IconButton onClick={() => EditItem(data)}>
      <EditIcon fontSize="small" />
    </IconButton>
  );

  const statusStyle = (data) => (
    <Tooltip placement="top" arrow title={data.statusDesc !== null ? data.statusDesc : ''}>
      <Box sx={{ color: 'warning.main', fontWeight: 'bold', cursor: 'pointer' }}>{data.status}</Box>
    </Tooltip>
  );

  return columns.map((column) => {
    const value = row[column.id];

    if (column.id === 'status'){
      console.log(value.status);
      console.log(value);
    }

    
    return (
      <TableCell
        key={column.id}
        align={column.align}
      >
        {column.format &&
        typeof value === "number"
          ? column.id === "id"
            ? editIcon(value)
            : column.format(value)
          : column.id === "id"
          ? editIcon(value)
          : (column.id === 'status') ? statusStyle (row)
          : value}
      </TableCell>
    );
  });
};
export default TableBodyCellComponent;
